import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import LazyLoad from 'react-lazyload';
import { Head } from '@dom/components';

import { CardsSlider, FAQs, UVP, FeaturedGuides } from '../../components';
import GuideSearchForm from './GuideSearchForm';
import { LodgeCard, AllReviews, SidebarReviews } from './imports';
import GuidePopularSearches from './GuidePopularSearches';
import CoronaVirusNotice from './CoronaVirusNotice';

import './home.scss';

const bgImages = 'url(https://s3.amazonaws.com/honeyguide/assets/guide-bg.jpg)';
const title = 'Trekking Guides and Porter-Guides for Nepal Himalayas';
const subText = '250+ Highly-Recommended and Independent Guides.';

export default function Home() {
  return (
    <Head title="Trekking Guides and Porter-Guides for Nepal">
      <Container fluid={true} className="mt--1">
        <Row>
          <div className="container-bg" style={{ backgroundImage: bgImages }}>
            <Container className="full-height flex-with-center flex-column">
              <div className="search-panel">
                <h1 class="ft-page-title">{title}</h1>
                <p className="sub">{subText}</p>
                <GuideSearchForm />
                <GuidePopularSearches />
              </div>
            </Container>
            <CoronaVirusNotice/>
          </div>
        </Row>
      </Container>
      <Container>
        <CoronaVirusNotice onMobile/>
        <UVP />
        <Row>
          <Col lg={{ size: 8, order: 1 }} md={{ size: 12, order: 2 }}>
            <LazyLoad offset={100}>
            <FeaturedGuides title="Featured Guides In Lukla" city="lukla" />
            <FeaturedGuides title="Featured Guides In Pokhara" city="pokhara" />
            <FeaturedGuides title="Featured Guides In Kathmandu" city="kathmandu" />
              <CardsSlider
                title="Featured Lodges"
                endpoint="lodgings/lodges?is_featured=1"
                Card={LodgeCard}
                showNoOfCards={3}
              />
            </LazyLoad>
            <AllReviews />
            <FAQs />
          </Col>
          <Col lg={{ size: 4, order: 2 }} md={{ size: 12, order: 1 }}>
            <SidebarReviews />
          </Col>
        </Row>
      </Container>
    </Head>
  );
}
